import { NOTIFICATION_REQUEST } from '@/store/actions/notifications';

const getters = {
  getNewNotificationCount: (state) => state.newNotificationCount,
};

const mutations = {
  [NOTIFICATION_REQUEST]: (state, { count }) => {
    state.newNotificationCount = count;
  },
};

const state = {
  newNotificationCount: 0,
};

export default () => ({
  getters,
  mutations,
  state,
});
